import React from 'react';
import { StyledPollQuestion, Link } from './PollQuestion.styles';
import env from '../../../../env';
import ExternalIcon from '../../../Link/ExternalIcon/ExternalIcon.jsx';

const PollQuestion = () => (
    <StyledPollQuestion>
        <Link href={`${env.STARTPAGE_POLL_URL}`}>
            <ExternalIcon isExternal={true}>
                <span className="play_external-teaser__poll-text">
                    Hjälp oss att förbättra SVT Play! Svara på en kort enkät här.
                </span>
            </ExternalIcon>
        </Link>
    </StyledPollQuestion>
);

export default PollQuestion;
